import axios from 'axios'

export function setAccessTokens(accessToken, refreshToken, refreshTokenExpiresAt) {
    localStorage.setItem('access', accessToken)
    localStorage.setItem('refresh', refreshToken)
    localStorage.setItem('refreshEndTime', refreshTokenExpiresAt)
    window.dispatchEvent(new Event('accessTokensUpdated'))

    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
}

export function clearAccessTokens() {
    localStorage.removeItem('access')
    localStorage.removeItem('refresh')
    localStorage.removeItem('refreshEndTime')

    window.dispatchEvent(new Event('accessTokensUpdated'))
    axios.defaults.headers.common['Authorization'] = false
}

export function getRefreshToken() {
    return localStorage.getItem('refresh')
}

export function getAccessToken() {
    return localStorage.getItem('access')
}

export function setCookie(name, value, time?: string) {
    let d = new Date()

    if (time) {
        d = new Date(time)
    } else {
        const defaultDays = 30

        d.setTime(d.getTime() + defaultDays * 24 * 60 * 60 * 1000)
    }
    const expires = `expires=${d.toUTCString()}`

    document.cookie = `${name}=${value};${expires};path=/`
}

export function getCookie(cname: string) {
    const name = `${cname}=`
    const decodedCookie = decodeURIComponent(document.cookie)
    const ca = decodedCookie.split(';')

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i]

        while (c.charAt(0) === ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
        }
    }

    return null
}

export function deleteCookie(name) {
    const expires = 'expires=Thu, 01 Jan 1970 00:00:00 UTC'

    document.cookie = `${name}=;${expires};path=/`
}
